var _polygon, _polygon2, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOptionsCentre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1079.33px",
    height: "1080px",
    viewBox: "0 0 1079.33 1080",
    enableBackground: "new 0 0 1079.33 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-options-centre") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "973.211,250.677 857.558,347.149 163.259,347.149 163.259,154.204 857.558,154.204 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.708,597.826 240.361,501.354 934.66,501.354 934.66,694.3 240.361,694.3 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 471.858,
    width: 77.102,
    height: 347.149
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 471.858,
    y: 385.7,
    width: 77.102,
    height: 308.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 471.858,
    y: 732.851,
    width: 77.102,
    height: 347.149
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptionsCentre);
export default __webpack_public_path__ + "static/media/icon-options-centre.cd71602f4a3b23f0552abf594b7c2794.svg";
export { ForwardRef as ReactComponent };